
import React, { useState } from "react";
import { Send } from "lucide-react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");

    if (
      !formData.name ||
      !formData.email ||
      !formData.subject ||
      !formData.message
    ) {
      setError("Veuillez remplir tous les champs");
      setLoading(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.email)) {
      setError("Veuillez entrer une adresse email valide");
      setLoading(false);
      return;
    }

    setTimeout(() => {
      setSubmitted(true);

      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });

      setLoading(false);

      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    }, 1500);
  };

  return (
    <section
      id="contact"
      className="w-full bg-slate-950 px-4 py-20 sm:px-6 lg:px-8"
    >
      <div className="mx-auto max-w-7xl">

        {/* Header */}
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Nous contacter
          </h2>

          <p className="mt-4 text-base text-gray-400 sm:text-lg">
            Une question ? Nous sommes là pour vous aider 24/7
          </p>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">

          {/* Contact Information */}
          <div
            className="
              rounded-2xl
              border border-white/10
              bg-white/5
              p-6
              shadow-xl
              backdrop-blur-xl
              sm:p-8
            "
          >
            <h3 className="mb-8 text-2xl font-bold text-white">
              Informations de contact
            </h3>

            {/* Email */}
            <div className="mb-7 flex gap-4">
              <div
                className="
                  flex h-12 w-12 flex-shrink-0
                  items-center justify-center
                  rounded-xl
                  bg-blue-500/10
                  text-2xl
                "
              >
                📧
              </div>

              <div>
                <h4 className="font-semibold text-white">
                  Email
                </h4>

                <a
                  href="mailto:support@servicetv.fr"
                  className="
                    mt-1 block
                    text-blue-400
                    transition-colors
                    hover:text-blue-300
                  "
                >
                  sservicesupport@gmail.com
                </a>

                <p className="mt-1 text-sm text-gray-400">
                  Réponse en moins de 2 heures
                </p>
              </div>
            </div>

            {/* Téléphone */}
            <div className="mb-7 flex gap-4">
              <div
                className="
                  flex h-12 w-12 flex-shrink-0
                  items-center justify-center
                  rounded-xl
                  bg-blue-500/10
                  text-2xl
                "
              >
                📞
              </div>

              <div>
                <h4 className="font-semibold text-white">
                  Téléphone
                </h4>

                <a
                  href="tel:+33612345678"
                  className="
                    mt-1 block
                    text-blue-400
                    transition-colors
                    hover:text-blue-300
                  "
                >
                  +44 (7308) 508-638                </a>

                <p className="mt-1 text-sm text-gray-400">
                  Lun-Dim : 08:00 - 22:00
                </p>
              </div>
            </div>

            {/* Adresse */}
            <div className="mb-7 flex gap-4">
              <div
                className="
                  flex h-12 w-12 flex-shrink-0
                  items-center justify-center
                  rounded-xl
                  bg-blue-500/10
                  text-2xl
                "
              >
                📍
              </div>

              <div>
                <h4 className="font-semibold text-white">
                  Adresse
                </h4>

                <p className="mt-1 text-sm leading-6 text-gray-400">
                  12 Rue de la République
                  <br />
                  75001 Paris
                  <br />
                  France
                </p>
              </div>
            </div>

            
          </div>

          {/* Contact Form */}
          <div
            className="
              rounded-2xl
              border border-white/10
              bg-white/5
              p-6
              shadow-xl
              backdrop-blur-xl
              sm:p-8
            "
          >
            <form onSubmit={handleSubmit}>

              {/* Success */}
              {submitted && (
                <div
                  className="
                    mb-6
                    rounded-xl
                    border border-green-500/20
                    bg-green-500/10
                    px-4 py-3
                    text-sm
                    font-medium
                    text-green-400
                  "
                >
                  ✓ Merci ! Votre message a été envoyé avec succès.
                </div>
              )}

              {/* Error */}
              {error && (
                <div
                  className="
                    mb-6
                    rounded-xl
                    border border-red-500/20
                    bg-red-500/10
                    px-4 py-3
                    text-sm
                    font-medium
                    text-red-400
                  "
                >
                  ✕ {error}
                </div>
              )}

              {/* Name */}
              <div className="mb-5">
                <label
                  htmlFor="name"
                  className="mb-2 block text-sm font-medium text-gray-200"
                >
                  Nom complet *
                </label>

                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Jean Dupont"
                  value={formData.name}
                  onChange={handleChange}
                  className="
                    w-full
                    rounded-xl
                    border border-white/10
                    bg-black/20
                    px-4 py-3
                    text-white
                    placeholder-gray-500
                    outline-none
                    transition
                    focus:border-blue-500
                    focus:ring-2
                    focus:ring-blue-500/20
                  "
                />
              </div>

              {/* Email */}
              <div className="mb-5">
                <label
                  htmlFor="email"
                  className="mb-2 block text-sm font-medium text-gray-200"
                >
                  Email *
                </label>

                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="jean@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  className="
                    w-full
                    rounded-xl
                    border border-white/10
                    bg-black/20
                    px-4 py-3
                    text-white
                    placeholder-gray-500
                    outline-none
                    transition
                    focus:border-blue-500
                    focus:ring-2
                    focus:ring-blue-500/20
                  "
                />
              </div>

              {/* Subject */}
              <div className="mb-5">
                <label
                  htmlFor="subject"
                  className="mb-2 block text-sm font-medium text-gray-200"
                >
                  Sujet *
                </label>

                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="Sujet de votre message"
                  value={formData.subject}
                  onChange={handleChange}
                  className="
                    w-full
                    rounded-xl
                    border border-white/10
                    bg-black/20
                    px-4 py-3
                    text-white
                    placeholder-gray-500
                    outline-none
                    transition
                    focus:border-blue-500
                    focus:ring-2
                    focus:ring-blue-500/20
                  "
                />
              </div>

              {/* Message */}
              <div className="mb-6">
                <label
                  htmlFor="message"
                  className="mb-2 block text-sm font-medium text-gray-200"
                >
                  Message *
                </label>

                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  placeholder="Écrivez votre message ici..."
                  value={formData.message}
                  onChange={handleChange}
                  className="
                    w-full
                    resize-none
                    rounded-xl
                    border border-white/10
                    bg-black/20
                    px-4 py-3
                    text-white
                    placeholder-gray-500
                    outline-none
                    transition
                    focus:border-blue-500
                    focus:ring-2
                    focus:ring-blue-500/20
                  "
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={loading}
                className="
                  flex w-full
                  items-center justify-center
                  gap-2
                  rounded-xl
                  bg-blue-600
                  px-6 py-3
                  font-semibold
                  text-white
                  shadow-lg
                  shadow-blue-600/20
                  transition-all duration-300
                  hover:bg-blue-500
                  hover:-translate-y-0.5
                  disabled:cursor-not-allowed
                  disabled:opacity-60
                  disabled:hover:translate-y-0
                "
              >
                <Send size={20} />

                {loading
                  ? "Envoi en cours..."
                  : "Envoyer le message"}
              </button>

            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
